export default __webpack_public_path__ + "static/media/Box_3_Customisation.dbaab6cd.png";